module.exports = __webpack_public_path__ + "img/r-icon-4.a9c1a77d.png";